import axios from 'axios';
import { toast } from 'react-toastify';
import { push } from 'connected-react-router';

// URIs
import serverURI from '../../config/URI';
// Helpers
import errorHandler from '../helpers/errorHandler';

export const LOADING_ADVERTISES = () => ({ type: 'LOADING_ADVERTISES', });
export const LOADING_ADVERTISES_SUCCESS = () => ({ type: 'LOADING_ADVERTISES_SUCCESS', });
export const LOADING_ADVERTISES_ERROR = () => ({ type: 'LOADING_ADVERTISES_ERROR', });

export const ADDING_ADVERTISE = () => ({ type: 'ADDING_ADVERTISE', });
export const ADDING_ADVERTISE_SUCCESS = () => ({ type: 'ADDING_ADVERTISE_SUCCESS', });
export const ADDING_ADVERTISE_ERROR = () => ({ type: 'ADDING_ADVERTISE_ERROR', });

export const UPDATING_ADVERTISE = () => ({ type: 'UPDATING_ADVERTISE', });
export const UPDATING_ADVERTISE_SUCCESS = () => ({ type: 'UPDATING_ADVERTISE_SUCCESS', });
export const UPDATING_ADVERTISE_ERROR = () => ({ type: 'UPDATING_ADVERTISE_ERROR', });

export const DELETING_ADVERTISE = () => ({ type: 'DELETING_ADVERTISE', });
export const DELETING_ADVERTISE_SUCCESS = () => ({ type: 'DELETING_ADVERTISE_SUCCESS', });
export const DELETING_ADVERTISE_ERROR = () => ({ type: 'DELETING_ADVERTISE_ERROR', });

//export const UPDATING_ADVERTISE_CHECKS = () => ({ type: 'UPDATING_ADVERTISE_CHECKS', });

export const FINDING_ADVERTISES = () => ({ type: 'FINDING_ADVERTISES', });
export const FINDING_ADVERTISES_SUCCESS = () => ({ type: 'FINDING_ADVERTISES_SUCCESS', });
export const FINDING_ADVERTISES_ERROR = () => ({ type: 'FINDING_ADVERTISES_ERROR', });

export const getAdvertises = (template, category, dispatch) => {
  dispatch({ type: LOADING_ADVERTISES });

  axios
    .get(`${serverURI}/api/advertise/advertise/all/${template}/${category}`)
    .then((res) => {
      dispatch({
        type: LOADING_ADVERTISES_SUCCESS,
        payload: {
          moviePath: res.data.movie_path,
          advertises: res.data.advertises
        }
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_ADVERTISES_ERROR, payload: err });
      errorHandler(err);
    });
};

export const addAdvertise = (template, category, advertise, dispatch) => {
  dispatch({ type: ADDING_ADVERTISE });

  console.log(advertise);

  const advertiseData = new FormData();
  
  advertiseData.append('template', template);
  advertiseData.append('type', advertise.type);
  advertiseData.append('category', category);
  advertiseData.append('name', advertise.name);
  advertiseData.append('movie', advertise.movie);
  advertiseData.append('video_file', advertise.video_file);
  advertiseData.append('filesize', advertise.video_file_size);
  advertiseData.append('image', advertise.image);
  advertiseData.append('image_file', advertise.image_file);
  advertiseData.append('playtime', advertise.playtime);
  advertiseData.append('agency', advertise.agency);
  advertiseData.append('client', advertise.client);
  advertiseData.append('volume', advertise.volume);
  advertiseData.append('start_date', advertise.start_date);
  advertiseData.append('end_date', advertise.end_date);
  advertiseData.append('view_count', advertise.view_count);
  advertiseData.append('cost', advertise.cost);
  advertiseData.append('start_time', advertise.start_time);
  advertiseData.append('end_time', advertise.end_time);
  advertiseData.append('area', advertise.area);
  advertiseData.append('state', advertise.state);
  advertiseData.append('district', advertise.district);
  advertiseData.append('xpos', advertise.xpos);
  advertiseData.append('ypos', advertise.ypos);
  advertiseData.append('welcome', advertise.welcome);
  advertiseData.append('modified_user', advertise.modified_user);
  advertiseData.append('modified_at', advertise.modified_at);

  

  axios
    .post(`${serverURI}/api/advertise/advertise/add`, advertiseData)
    .then((res) => {
      dispatch({ type: ADDING_ADVERTISE_SUCCESS, 
        payload: res.data.advertise, 
        });
    })
    .catch((err) => {
      dispatch({ type: ADDING_ADVERTISE_ERROR, payload: err });
      errorHandler(err);
    });
};

export const updateAdvertise = (template, category, id, advertise, dispatch) => {
  dispatch({ type: UPDATING_ADVERTISE });

  const advertiseData = new FormData();
  
  advertiseData.append('template', template);
  advertiseData.append('type', advertise.type);
  advertiseData.append('category', category);
  advertiseData.append('name', advertise.name);
  advertiseData.append('movie', advertise.movie);
  advertiseData.append('prev_movie', advertise.prev_movie);
  advertiseData.append('video_file', advertise.video_file);
  advertiseData.append('filesize', advertise.video_file_size);
  advertiseData.append('image', advertise.image);
  advertiseData.append('prev_image', advertise.prev_image);
  advertiseData.append('image_file', advertise.image_file);
  advertiseData.append('playtime', advertise.playtime);
  advertiseData.append('agency', advertise.agency);
  advertiseData.append('client', advertise.client);
  advertiseData.append('volume', advertise.volume);
  advertiseData.append('start_date', advertise.start_date);
  advertiseData.append('end_date', advertise.end_date);
  advertiseData.append('view_count', advertise.view_count);
  advertiseData.append('cost', advertise.cost);
  advertiseData.append('start_time', advertise.start_time);
  advertiseData.append('end_time', advertise.end_time);
  advertiseData.append('area', advertise.area);
  advertiseData.append('state', advertise.state);
  advertiseData.append('district', advertise.district);
  advertiseData.append('modified_user', advertise.modified_user);
  advertiseData.append('modified_at', advertise.modified_at);

  axios
    .put(`${serverURI}/api/advertise/advertise/update/${id}`, advertiseData)
    .then((res) => {
      //console.log(res);
      dispatch({ type: UPDATING_ADVERTISE_SUCCESS, 
        payload: res.data.updated_advertise, 
        });
    })
    .catch((err) => {
      dispatch({ type: UPDATING_ADVERTISE_ERROR, payload: err });
      errorHandler(err);
    });
};

export const deleteAdvertises = (template, deletes, dispatch) => {
  dispatch({ type: DELETING_ADVERTISE });

  const deleteData = {
    template: template,
    deletes: deletes,
  };

  return axios
    .delete(`${serverURI}/api/advertise/advertise/delete`, {data: deleteData})
    .then((res) => {
      dispatch({ type: DELETING_ADVERTISE_SUCCESS, 
        payload: res.data.deletedAdvertises,
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_ADVERTISE_ERROR, payload: err });
      errorHandler(err);
    });
};



export const findAdvertises = (find, dispatch) => {
  dispatch({ type: FINDING_ADVERTISES });

  axios
    .post(`${serverURI}/api/advertise/advertise/find`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_ADVERTISES_SUCCESS, 
        payload: {
          find_moviePath: res.data.movie_path,
          find_total: res.data.total,
          find_advertises: res.data.advertises
        }
        });
    })
    .catch((err) => {
      dispatch({ type: FINDING_ADVERTISES_ERROR, payload: err });
      errorHandler(err);
    });
};

export const removeAdvertises = (dispatch) => {
  dispatch({ type: FINDING_ADVERTISES_SUCCESS, 
    payload: {
      find_moviePath: '',
      find_total: 0,
      find_advertises: []
    }
  });

};